import { render } from "./aboutuspage.vue?vue&type=template&id=cbfa6274&scoped=true"
import script from "./aboutuspage.vue?vue&type=script&lang=js"
export * from "./aboutuspage.vue?vue&type=script&lang=js"

import "./aboutuspage.vue?vue&type=style&index=0&id=cbfa6274&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbfa6274"]])

export default __exports__